import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type ProductType = {
    id: number
    title: string
    value: string
}

export type ProductTypeDto = {
    title: string
    value: string
}

export const productTypeApi = createApi({
    reducerPath: 'productTypeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ['PRODUCT-TYPE'],
    endpoints: builder => ({
        getAllProductTypes: builder.query<ProductType[], void>({
            query: () => ({ url: `/product-types` }),
            providesTags: ['PRODUCT-TYPE']
        }),
        getAllProductTypesEn: builder.query<ProductType[], void>({
            query: () => ({ url: `/product-types?lang=en` }),
            providesTags: ['PRODUCT-TYPE']
        }),
        getProductType: builder.query<ProductType, { id: number }>({
            query: ({ id }) => ({ url: `/product-types/${id}` }),
            providesTags: ['PRODUCT-TYPE']
        }),
        createProductType: builder.mutation<any, ProductTypeDto>({
            query: data => ({ url: `/product-types`, method: 'POST', body: data }),
            extraOptions: { includeToken: true },
            invalidatesTags: ['PRODUCT-TYPE']
        }),
        deleteProductTypesByIds: builder.mutation<any, any>({
            query: data => ({ url: `/product-types/delete/byIds`, method: 'POST', body: data }),
            extraOptions: { includeToken: true },
            invalidatesTags: ['PRODUCT-TYPE']
        }),
        updateProductTypes: builder.mutation<any, any>({
            query: data => ({ url: `/product-types/${data.id}`, method: 'PATCH', body: data }),
            extraOptions: { includeToken: true },
            invalidatesTags: ['PRODUCT-TYPE']
        }),
        updateProductTypesEn: builder.mutation<any, any>({
            query: data => ({
                url: `/product-types/en/update/${data.id}`,
                method: 'PATCH',
                body: { title: data.title }
            }),
            invalidatesTags: ['PRODUCT-TYPE']
        })
    })
})

export const {
    useGetAllProductTypesQuery,
    useGetAllProductTypesEnQuery,
    useGetProductTypeQuery,
    useCreateProductTypeMutation,
    useDeleteProductTypesByIdsMutation,
    useUpdateProductTypesMutation,
    useUpdateProductTypesEnMutation
} = productTypeApi
